import { render } from "./Inidicador.vue?vue&type=template&id=71358c64"
import script from "./Inidicador.vue?vue&type=script&lang=js"
export * from "./Inidicador.vue?vue&type=script&lang=js"

import "./Inidicador.vue?vue&type=style&index=0&id=71358c64&scope=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__